module.exports = __webpack_public_path__ + "static/media/almeirim.7268fbee.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/assets/almeirim.png
// module id = 545
// module chunks = 0